'use client';

import { CONSENT_DIALOG_ID } from '@numa-group/features.consent-management';
import { createDialogCoordination } from '@numa-group/features.dialog-orchestration';

/**
 * The app's dialog coordination, bound to its single declared ordering for
 * every auto-opening dialog (TE-947). Lower value = higher priority: consent
 * always first, then the city-tax payment, then the check-in login prompt.
 * New auto-opening dialogs get an entry here, never an inline priority.
 *
 * Mount the provider once per router, above `UserConsentProvider` so the
 * consent slot it carries can register. Register dialogs only through
 * `useCoordinatedAppDialog` — it rejects undeclared ids at compile time.
 */
export const { DialogCoordinatorProvider: AppDialogCoordinator, useCoordinatedDialog: useCoordinatedAppDialog } =
  createDialogCoordination({
    priorities: {
      [CONSENT_DIALOG_ID]: 0,
      cityTaxPayment: 1,
      checkinLoginPrompt: 2,
    },
  });
